module.exports = __webpack_public_path__ + "static/media/logo-escritorio-modelo2.576046f4.png";